import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import TipoDocumentoSunat from 'constants/tiposDeDocumentoSunat'

const TipoDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO DOC' htmlFor='select-tipoDocumento' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='tipoDocumento'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-tipoDocumento'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
            >
              {TipoDocumentoSunat.__guiasOrdenArray.map((x, k) => (
                <option key={k} value={x.id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoDocumentoFormGroup)
